import React, { FC } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { Backdrop } from "@mui/material";

interface ModalLoaderProps {
	open: boolean;
	transparancy: number;
}

export const ModalLoader: FC<ModalLoaderProps> = ({ open, transparancy }) => {
	const backgroundColor = "rgba(0, 0, 0," + transparancy + ")";
	return (
		<Backdrop
			open={open}
			sx={{
				backgroundColor: backgroundColor,
				zIndex: (theme) => theme.zIndex.drawer + 1,
			}}
		>
			<CircularProgress />
		</Backdrop>
	);
};
